import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ResultOption } from './result-option.component';

import { AutocompletePrediction } from '@/types/google-maps.types';

export type LocationSearchResultsProps = {
  searchResults: AutocompletePrediction[];
  handleLocationClick: (item: AutocompletePrediction) => Promise<void>;
};

export const LocationSearchResults = ({
  searchResults,
  handleLocationClick,
}: LocationSearchResultsProps) => {
  return (
    <div
      className="flex flex-col gap-5"
      data-testid={DataTestIdEnum.LOCATION_RESULT_SEARCH}
    >
      {searchResults.map((result) => (
        <ResultOption
          key={`key-result${result?.placeId ?? ''}`}
          description={result.description}
          callback={async () => {
            await handleLocationClick(result);
          }}
        />
      ))}
    </div>
  );
};
